import $ from 'jquery';
import Awesomplete from 'awesomplete';
import debounce from './debounce';

const KEY_LEFT = 37;
const KEY_RIGHT = 39;
const KEY_DOWN = 40;
const KEY_UP = 38;
const KEY_SHIFT = 16;
const KEY_ESCAPE = 27;

const IGNORED_KEYS = [KEY_UP, KEY_DOWN, KEY_RIGHT, KEY_LEFT, KEY_SHIFT, KEY_ESCAPE];

export default class AwesompleteWrapper {
  constructor(options) {
    this.inputElement = options.inputElement;
    this.itemRenderer = options.itemRenderer;
    this.replace = options.replace;
    this.apiUrl = options.api;
    this.list = [];

    this.awesomplete = new Awesomplete(this.inputElement, {
      maxItems: 10,
      minChars: 3,
      list: [],
      filter: AwesompleteWrapper.filter,
      item: this.item.bind(this),
      replace: this.replace,
      sort: () => 0,
    });

    this.onKeyupBound = this.onKeyup.bind(this);

    this.inputElement.addEventListener('keyup', this.onKeyupBound);

    this.debouncedSearch = debounce(this.search.bind(this), 250);
  }

  destroy() {
    this.inputElement.removeEventListener('keyup', this.onKeyupBound);
  }

  search(searchQuery) {
    if (searchQuery.length < 3) {
      this.list = [];
      this.awesomplete.list = this.list;
      this.awesomplete.evaluate();
      return;
    }

    $.ajax({
      url: `${this.apiUrl}${searchQuery}`,
      type: 'GET',
      dataType: 'json',
      success: (data) => {
        this.list = data;
        this.awesomplete.list = data;
        this.awesomplete.evaluate();
      },
    });
  }

  onKeyup(e) {
    if (IGNORED_KEYS.indexOf(e.keyCode) >= 0) {
      return;
    }

    const searchQuery = e.target.value;
    this.debouncedSearch(searchQuery);
  }

  static filter() {
    return true;
  }

  item(obj) {
    return $('<li>', {
      html: this.itemRenderer(obj, this.list),
      'aria-selected': 'false',
      class: 'awesomplete__item',
    })[0];
  }
}
